export default function Footer() {
  return (
    <footer
      data-testid="landing-footer"
      className="animate-stagger-6 px-5 pt-8 pb-24 border-t border-gray-200"
    >
      <div className="flex flex-col items-center text-center gap-5">
        <img
          src="https://customer-assets.emergentagent.com/job_worship-tracks-5/artifacts/twg4kldp_LOGO%20Iglesia%202.png"
          alt="Tu Iglesia App"
          data-testid="footer-logo"
          className="w-32"
          loading="lazy"
        />

        <p className="text-xs text-[#4B5563] max-w-xs leading-relaxed">
          Tu Iglesia App &mdash; Conectando a la feligresía con su congregación
          a través de la tecnología y la fe.
        </p>

        <div className="flex items-center gap-4 text-[10px] text-[#6B7280]">
          <a href="#terminos" className="hover:text-[#056A84] transition-colors">Términos de Uso</a>
          <span className="text-gray-300">|</span>
          <a href="#privacidad" className="hover:text-[#056A84] transition-colors">Privacidad</a>
          <span className="text-gray-300">|</span>
          <a href="#contacto" className="hover:text-[#056A84] transition-colors">Contacto</a>
        </div>

        <p className="text-[10px] text-[#9CA3AF]">
          &copy; {new Date().getFullYear()} Tu Iglesia. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
